var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "app-form-buttons",
      class: _vm.className,
      attrs: { color: "white", flat: "" },
    },
    [
      _c(
        "v-flex",
        { staticClass: "back-btn", attrs: { id: _vm.customModalLayout } },
        [
          _c(
            "div",
            [
              !_vm.noBackButton
                ? _c(
                    "v-btn",
                    { attrs: { color: "secondary" }, on: { click: _vm.back } },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.backButtonText) + "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "buttons-right" },
            [
              !_vm.noClear
                ? _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: {
                        id: "btn-clean",
                        disabled: _vm.disabled,
                        color: "secondary",
                      },
                      on: { click: _vm.clear },
                    },
                    [_vm._v("\n        Limpar\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.cancelButton
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "light-gray" },
                      on: { click: _vm.cancel },
                    },
                    [_vm._v("\n        Cancelar\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.noSave
                ? _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: {
                        id: "btn-save",
                        disabled: _vm.disabled,
                        color: "primary",
                      },
                      on: { click: _vm.save },
                    },
                    [_vm._v("\n        " + _vm._s(_vm.saveText) + "\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.onlySave && !_vm.noSave
                ? _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { id: "btn-save-new", color: "primary" },
                      on: { click: _vm.saveAndNew },
                    },
                    [_vm._v("\n        Salvar e Novo\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }